module.exports = __webpack_public_path__ + "static/media/SignBoard2.3cfeb748.glb";